"use client";
import ArmyInfoView from "@/components/list-builder/army-info/ArmyInfoView";
import ShareBookDialog, {
  getShareBookUrl,
  handleShareArmyBook
} from "@/components/list-builder/ShareBookDialog";
import { ArmyInfoMenuBar } from "@/components/menu/ArmyInfoMenuBar";
import { getArmyBookData } from "@/data/redux/armySlice";
import { useAppDispatch, useAppSelector } from "@/data/redux/store";
import { GameSystems } from "@/data/types";
import useGetGenericName from "@/hooks/useGetGenericName";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export default function ArmyInfoPage({
  gameSystem,
  armyId,
  armyName: armyNameQuery,
  append
}: {
  gameSystem: GameSystems;
  armyId: string;
  armyName: string;
  append: boolean;
}) {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const { loadedArmyBooks } = useAppSelector((state) => state.army);
  const armyData = loadedArmyBooks.find((x) => x.uid === armyId);
  const displayArmyName = useGetGenericName()(armyData);

  useEffect(() => {
    if (!armyData || armyId !== armyData.uid) {
      dispatch(
        getArmyBookData({
          armyUids: [armyId],
          gameSystem,
          reset: !append
        })
      );
    }
  }, [armyData, armyId]);

  const onBookReported = () => router.back();

  return (
    <>
      <ArmyInfoMenuBar title={displayArmyName ?? armyNameQuery ?? "Loading"} armyData={armyData} />
      <ArmyInfoView
        armyData={armyData}
        onBookReported={onBookReported}
        handleShare={() => handleShareArmyBook(armyData.name, setShareDialogOpen, gameSystem, armyData.uid)}
        showHero={false}
      />
      {armyData && (
        <ShareBookDialog
          open={shareDialogOpen}
          setOpen={setShareDialogOpen}
          title={`Share ${armyData.name} book`}
          url={getShareBookUrl(gameSystem, armyData.uid, armyData.name)}
        />
      )}
    </>
  );
}
